<template>
	<div>
		<v-progress-linear :active="loading" absolute indeterminate class="ml-3 mr-3" color="green"></v-progress-linear>
		<main-table
				v-if="listItems"
				default-sort-by="id"
				:default-sort-desc="true"
				:flag="flag"
				:pageTitle="title"
				:headers="headers"
				:listItems="listItems"
				:filtersList="listItemsFilter"
				:isCreate="false"
				:isExport="false"
				@updateClickButton="onClickButton"
				@updateSearch="onFilter"
				@updateRefreshFilters="onFilter"
				@updateChangeSort="onFilter"
		></main-table>
		<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link"/>

		<confirm-email-sending
				v-if="isConfirm"
				:email="sendMail"
				@updateConfirmItem="sendReport"
				@updateConfirmClose="onConfirmClose"
				@updateConfirmEmailSending="onConfirmEmailSending"
		></confirm-email-sending>
	</div>
</template>
<script>
import { mapActions } from "vuex";
import PreviewDoc from "@/modules/invoices/preview";
// constants
import { reportHeader } from "@/constants/defaultHeader";
import { getAppUrl } from "@/services";
import ConfirmEmailSending
from "@/components/Statistics/ReportsOld/Reports-list/ConfirmEmailSending/ConfirmEmailSending.vue";

export default {
	name: "ReportList",
	components: { ConfirmEmailSending, PreviewDoc },
	props: {
		listItems: Array,
		listItemsFilter: Object,
		permissions: Object
	},
	computed: {
		headers() {
			return reportHeader;
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
		items: {
			get() {
				return this.list;
			},
			set(arr) {
				this.list = arr;
			},
		},
	},
	data() {
		return {
			title: "Dispatch",
			flag: "reportList",
			valid: true,
			lazy: false,
			loading: false,
			snackbar: false,
			snackbarPay: false,
			checkItemPay: null,
			checkItemSend: null,
			sendMail: null,
			emailRules: [
				(v) => !!v || "E-mail is required",
				(v) => /.+@.+/.test(v) || "E-mail must be valid",
			],
			vertical: true,
			filterUpdate: false,
			sortBy: "",
			sortDesc: false,
			page: 1,
			pageCount: 0,
			up: [],
			countItems: [ 5, 10, 15, 20, 50, 100, "All" ],
			itemsPerPage: 20,
			countItemsVal: 20,
			search: "",
			link: null,
			menu: false,
			preload: false,
			filtersMarker: {},
			filters: {
				id: [],
				customer: [],
				send_to: [],
				to: [],
				from: [],
				send_date: [],
				send_by: [],
			},
			filtersList: {
				id: [],
				customer: [],
				send_to: [],
				to: [],
				from: [],
				send_date: [],
				send_by: [],
			},
			list: this.listItems,
			itemRemove: null,
			checkClasses: {},
			isConfirm: false,
		};
	},
	methods: {
		...mapActions([
			'getReportsFilter',
		]),

		onConfirmClose() {
			this.isConfirm = false;
		},
		onConfirmEmailSending(value) {
			this.sendMail = value;
		},

		async onFilter(info) {
			await this.getReportsFilter(info.filterModList);
		},
		onClickButton({ key, item }) {
			if (key === "file") {
				this.previewAction(item.file);
			}
			if (key === "send") {
				this.sendInvoiceCheck(item);
			}
		},

		checkPages(e) {
			if (e !== "All") {
				this.itemsPerPage = parseInt(e, 10);
			} else {
				this.itemsPerPage = 999999999;
			}
		},
		validate() {
			this.$refs.form.validate();
		},
		sendInvoiceCheck(item) {
			this.checkItemSend = item;
			this.sendMail = item['send_to'];
			this.isConfirm = true;
		},
		async sendReport() {
			this.loading = true;
			const data = await this.$store.dispatch("sendReportToPost", {
				id: this.checkItemSend.id,
				email: this.sendMail,
			});

			if (data && data.status) {
				await this.$store.dispatch("setAlert", {
					type: "success",
					message: "Sending Successful",
				});
			} else {
				await this.$store.dispatch("setAlert", {
					type: "error",
					message: "Sending error",
				});
			}

			this.$emit('updateLists', 1);

			this.loading = false;
			this.isConfirm = false;
		},
		checkRemove(item) {
			this.itemRemove = item;
			this.snackbar = true;
		},
		removeItem() {
			this.$emit("remove-invoice", this.itemRemove);
			this.snackbar = false;
		},
		editInvoice(id) {
			this.$emit("edit-invoice", id);
		},
		refreshFilters() {
			this.countItemsVal = 20;
			this.itemsPerPage = 20;
			this.search = "";
			this.sortDesc = false;
			this.sortBy = "";
			this.items = this.listItems;
			this.page = 1;

			if (Object.values(this.filterClasses)) {
				for (const i in this.filters) {
					this.filters[i] = [];
				}

				this.filterUpdate = true;
			}
			this.setListsFilter(this.items);
		},

		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},

		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		setListsFilter(arr, col) {
			if (!col) {
				for (const i in this.filtersList) {
					this.filtersList[i] = [];
				}

				arr.forEach(item => {
					if (item.id) this.filtersList.id.push(item.id);
					if (item.customer) this.filtersList.customer.push(item.customer);
					if (item.send_to) this.filtersList.send_to.push(item.send_to);
					if (item.send_by) this.filtersList.send_by.push(item.send_by);
				});
			} else {
				if (col === "id") {
					this.filtersList.customer = [];
					this.filtersList.send_to = [];
					this.filtersList.send_by = [];

					for (const i in arr) {
						this.filtersList.customer.push(arr[i].customer);
						this.filtersList.send_to.push(arr[i].send_to);
						this.filtersList.send_by.push(arr[i].send_by);
					}
				}

				if (col === "customer") {
					this.filtersList.id = [];
					this.filtersList.send_to = [];
					this.filtersList.send_by = [];
					for (const i in arr) {
						this.filtersList.id.push(arr[i].id);
						this.filtersList.send_to.push(arr[i].send_to);
						this.filtersList.send_by.push(arr[i].send_by);
					}
				}

				if (col === "send_to") {
					this.filtersList.id = [];
					this.filtersList.customer = [];
					this.filtersList.send_by = [];
					for (const i in arr) {
						this.filtersList.id.push(arr[i].id);
						this.filtersList.customer.push(arr[i].customer);
						this.filtersList.send_by.push(arr[i].send_by);
					}
				}

				if (col === "send_by") {
					this.filtersList.id = [];
					this.filtersList.customer = [];
					this.filtersList.send_to = [];

					for (const i in arr) {
						this.filtersList.id.push(arr[i].id);
						this.filtersList.customer.push(arr[i].customer);
						this.filtersList.send_to.push(arr[i].send_to);
					}
				}
			}
		},
		changeSort(val) {
			this.filters[val.key] = val.value;
			let arr = this.listItems;

			for (const item in this.filters) {
				if (this.filters[item].length) {
					arr = arr.filter((elem) => {
						if (item === "to" || item === "from" || item === "send_date") {
							if (this.filters[item].length === 2) {
								const firstDate = new Date(this.filters[item][0]).valueOf() - ((24 * 60 * 60 * 1000) - 1000);
								const lastDate = new Date(this.filters[item][1]).valueOf();
								const currentDate = new Date(elem[item]).valueOf();

								return currentDate >= firstDate && currentDate <= lastDate;
							}
						} else {
							const result = [];
							for (let i = 0; i < this.filters[item].length; i++) {
								if (elem[item] === this.filters[item][i]) {
									result.push(true);
								}
							}

							return result.length;
						}
					});
				}
			}
			this.filterClasses = this.filters;
			this.items = arr;
			if (
				val.key !== "to" ||
					val.key !== "from"
			) {
				this.setListsFilter(this.items, val.key);
			}
		},
		columnValueList(val) {
			return this.items.map((d) => d[val]);
		},
		modalOpen() {
			this.menu = !this.menu;
		},
		clearLink() {
			this.link = null;
		},
		previewAction(link) {
			this.link = getAppUrl + link;
		},
	},
	created() {
		for (let i = 0; i < this.headers.length; i++) {
			this.filtersMarker[this.headers[i].value] = true;
			this.checkClasses[this.headers[i].value] = false;
			this.filters[this.headers[i].value] = [];
			this.filtersList[this.headers[i].value] = [];
		}
	},
	watch: {
		preload(val) {
			this.$store.dispatch("actionPreloader", val);
		},
		listItems(val) {
			this.items = val;
			if (this.items.length) {
				this.setListsFilter(this.items);
			}
			if (val.length > 0) {
				this.preload = false;
			} else {
				this.preload = false;
			}
		},
		snackbar(val) {
			if (!val) {
				this.itemRemove = null;
			}
		},
		snackbarPay(val) {
			if (!val) {
				this.checkItemPay = null;
			}
		},
	},

};
</script>
<style lang="scss" scoped>
@import "./reports_list";
</style>
<style lang="scss">
.invoice-table {
	.v-data-table__wrapper {
		overflow-y: initial !important;
		overflow-x: initial !important;
	}

	&.v-data-table td {
		font-size: 12px !important;
		height: 36px !important;
	}
}
.tabReports {
	height: 100%;
}
.component-holder {
	height: 100%;
}
.pageList--content {
	height: calc(100% - 220px);
}
.pageList--wrap {
	padding: 10px 10px 0;
	//height: calc(100% - 240px);
}
</style>
